import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LEAD_BLITZSHARE } from '../../shared/constants/strings';
import { environment } from '../../../environments/environment';
import { ImgUrls } from '../../shared/models/imgUrls.interface';
import { UtilService } from '../../shared/util.service';
import { ImageCarouselModalContentComponent } from '../../shared/components/image-carousel-modal-content/image-carousel-modal-content.component';
import Util from '../../shared/util';
import { MetadataService } from '../../shared/services/metadata.service';
import { TitleService } from '../../shared/services/title.service';
import { ThumbnailWidgetComponent } from '../../shared/components/thumbnail-widget/thumbnail-widget.component';

const PHOTO_COUNT_OBJECT = 57;

@Component({
  selector: 'app-blitzshare',
  templateUrl: './blitzshare.component.html',
  styleUrls: ['./blitzshare.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatDialogModule, ThumbnailWidgetComponent],
})
export class BlitzshareComponent implements OnInit {
  activeImageIndexObject = 0;
  imgPath = environment.storageImgPath;
  imgPathBlitzshare = environment.storageImgPath + '/blitzshare/';
  titleImage = this.imgPathBlitzshare + 'blitzshare-canoe-w600.webp';
  imgUrlsObject: ImgUrls[] = [];

  constructor(
    private dialog: MatDialog,
    private metadataService: MetadataService,
    private utilService: UtilService,
    private titleService: TitleService,
  ) {}

  public get LEAD_BLITZSHARE() {
    return LEAD_BLITZSHARE;
  }

  ngOnInit(): void {
    this.titleService.setTitle(`Blitzshare`);
    this.metadataService.updateTags(
      `Blitzshare`,
      `Hier erfahren Sie mehr über meine Plattform blitzshare.de`,
      `Blitzshare.de Gründer Start-up sharing-community`,
      [this.titleImage],
    );

    this.createImgUrls(1, PHOTO_COUNT_OBJECT, 'carouselObject');
  }

  /**
   * Opens the given array of images in a carousel inside a modal.
   * @param selectedId the ID of the image to be selected at the beginning
   * @param imgUrls all images to be shown in the carousel
   */
  openImage(selectedId: number, imgUrls: ImgUrls[]): void {
    this.dialog.open(ImageCarouselModalContentComponent, {
      panelClass: 'image-carousel-dialog',
      data: { selectedId, imgUrls, altName: imgUrls[selectedId].title },
    });
  }

  selectImage(index: number, carousel: 'carouselObject') {
    this.setActiveIndex(carousel, index);
  }

  previousImage(carousel: 'carouselObject'): void {
    const { items, activeIndex } = this.getCarouselState(carousel);
    if (!items.length) return;
    const newIndex = (activeIndex - 1 + items.length) % items.length;
    this.setActiveIndex(carousel, newIndex);
  }

  nextImage(carousel: 'carouselObject'): void {
    const { items, activeIndex } = this.getCarouselState(carousel);
    if (!items.length) return;
    const newIndex = (activeIndex + 1) % items.length;
    this.setActiveIndex(carousel, newIndex);
  }

  getActiveImage(carousel: 'carouselObject'): ImgUrls | undefined {
    const state = this.getCarouselState(carousel);
    return state.items[state.activeIndex];
  }

  private createImgUrls(firstIndex: number, lastIndex: number, carousel: 'carouselObject') {
    switch (carousel) {
      case 'carouselObject':
        this.imgUrlsObject = [];
        for (let i = firstIndex; i <= lastIndex; i++)
          this.imgUrlsObject.push({
            w150: this.imgPathBlitzshare + `category${i}-w150.webp`,
            w350: this.imgPathBlitzshare + `category${i}-w350.webp`,
            w500: this.imgPathBlitzshare + `category${i}-w500.webp`,
            w750: this.imgPathBlitzshare + `category${i}-w750.webp`,
            w1124: this.imgPathBlitzshare + `category${i}-w1124.webp`,
            w1500: this.imgPathBlitzshare + `category${i}-w1500.webp`,
            full: this.imgPathBlitzshare + `category${i}-w2000.webp`,
            title: `Kategorienfoto ${i}`,
          });
        break;
    }
    Util.shuffle(this.imgUrlsObject);
  }

  private getCarouselState(carousel: 'carouselObject') {
    switch (carousel) {
      case 'carouselObject':
        return { items: this.imgUrlsObject, activeIndex: this.activeImageIndexObject };
    }
  }

  private setActiveIndex(carousel: 'carouselObject', index: number): void {
    switch (carousel) {
      case 'carouselObject':
        this.activeImageIndexObject = index;
        break;
    }
    this.utilService.scrollToId(carousel);
  }
}
